var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{staticClass:"mx-1 poppins",attrs:{"outlined":"","items":_vm.filter['values'],"label":_vm.filter.title,"item-text":"text","item-value":"index","dense":"","clearable":""},model:{value:(_vm.filterData),callback:function ($$v) {_vm.filterData=$$v},expression:"filterData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }